let capabilityRequest;
let accessCatalog = [];
let catalogSyncRequest;

export function configureAccessCatalog(items) {
    accessCatalog = Array.isArray(items) ? items : [];
}

async function syncCatalogIfStaff(store, workApi, identityToken) {
    if (!store.getters.userdata?.admin || accessCatalog.length === 0) return;
    if (catalogSyncRequest?.token === identityToken) return catalogSyncRequest.promise;
    const promise = workApi
        .post("/access/catalog/", { items: accessCatalog }, true)
        .finally(() => {
            if (catalogSyncRequest?.promise === promise) catalogSyncRequest = undefined;
        });
    catalogSyncRequest = { token: identityToken, promise };
    return promise;
}

export async function ensureCapabilities(store, workApi) {
    if (!store.getters.isLoggedIn) return [];
    if (store.state.user.capabilitiesLoaded) return store.state.user.capabilities;
    const identityToken = store.getters.token;
    if (capabilityRequest?.token === identityToken) return capabilityRequest.promise;

    const promise = workApi.get("/access/capabilities/", {}, true)
        .then(async (response) => {
            if (store.getters.token !== identityToken) throw new Error("Identity changed while loading capabilities");
            const defined = response?.data?.defined_capabilities;
            const missing = !Array.isArray(defined) || accessCatalog.some(item => !defined.includes(item.key));
            if (store.getters.userdata?.admin && missing) {
                // New routes must be registered before any access decision.
                await syncCatalogIfStaff(store, workApi, identityToken);
                return workApi.get("/access/capabilities/", {}, true);
            }
            // Existing grants are authoritative; metadata synchronization need not hold navigation.
            syncCatalogIfStaff(store, workApi, identityToken)
                .catch(error => console.warn("Catalogo accessi non sincronizzato", error));
            return response;
        })
        .then((response) => {
            if (store.getters.token !== identityToken) {
                throw new Error("Identity changed while loading capabilities");
            }
            const capabilities = response?.data?.capabilities;
            const definedCapabilities = response?.data?.defined_capabilities || capabilities;
            if (!Array.isArray(capabilities) || capabilities.some((key) => typeof key !== "string")) {
                throw new Error("Invalid capabilities response");
            }
            if (!Array.isArray(definedCapabilities) || definedCapabilities.some((key) => typeof key !== "string")) {
                throw new Error("Invalid defined capabilities response");
            }
            store.commit("setCapabilities", { capabilities, definedCapabilities });
            return capabilities;
        })
        .finally(() => {
            if (capabilityRequest?.promise === promise) capabilityRequest = undefined;
        });
    capabilityRequest = { token: identityToken, promise };
    return promise;
}

export function menuCapabilityAllowed(item, store) {
    if (item.adminOnly === true && store.getters.userdata?.admin !== true) return false;
    if (!item.capability) return undefined;
    if (store.state.user.capabilitiesLoaded && store.getters.isCapabilityDefined(item.capability)) {
        return store.getters.hasCapability(item.capability);
    }
    return undefined;
}
